var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container"},[_c('author-jinNang-list',{attrs:{"list":_vm.authorjinNangList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }